/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as MaintenanceRouteImport } from './routes/maintenance'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ConsentRouteImport } from './routes/consent'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AuthSettingsRouteImport } from './routes/_auth/settings'
import { Route as AuthProfileRouteImport } from './routes/_auth/profile'
import { Route as AuthJobsRouteImport } from './routes/_auth/jobs'
import { Route as AuthHomeRouteImport } from './routes/_auth/_home'
import { Route as AuthHomeIndexRouteImport } from './routes/_auth/_home/index'
import { Route as AuthHomeReportRouteImport } from './routes/_auth/_home/report'
import { Route as AuthHomeTIndexRouteImport } from './routes/_auth/_home/t/index'
import { Route as AuthHomeTTripIdRouteImport } from './routes/_auth/_home/t/$tripId'
import { Route as AuthHomeReportExportRouteImport } from './routes/_auth/_home/report/export'
import { Route as AuthHomeReportReqIdRouteImport } from './routes/_auth/_home/report/$reqId'
import { Route as AuthHomeRReceiptIdRouteImport } from './routes/_auth/_home/r/$receiptId'
import { Route as AuthHomeTTripIdAddReceiptRouteImport } from './routes/_auth/_home/t/$tripId/add-receipt'

const MaintenanceRoute = MaintenanceRouteImport.update({
  id: '/maintenance',
  path: '/maintenance',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ConsentRoute = ConsentRouteImport.update({
  id: '/consent',
  path: '/consent',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSettingsRoute = AuthSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthRoute,
} as any)
const AuthProfileRoute = AuthProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthRoute,
} as any)
const AuthJobsRoute = AuthJobsRouteImport.update({
  id: '/jobs',
  path: '/jobs',
  getParentRoute: () => AuthRoute,
} as any)
const AuthHomeRoute = AuthHomeRouteImport.update({
  id: '/_home',
  getParentRoute: () => AuthRoute,
} as any)
const AuthHomeIndexRoute = AuthHomeIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthHomeRoute,
} as any)
const AuthHomeReportRoute = AuthHomeReportRouteImport.update({
  id: '/report',
  path: '/report',
  getParentRoute: () => AuthHomeRoute,
} as any)
const AuthHomeTIndexRoute = AuthHomeTIndexRouteImport.update({
  id: '/t/',
  path: '/t/',
  getParentRoute: () => AuthHomeRoute,
} as any)
const AuthHomeTTripIdRoute = AuthHomeTTripIdRouteImport.update({
  id: '/t/$tripId',
  path: '/t/$tripId',
  getParentRoute: () => AuthHomeRoute,
} as any)
const AuthHomeReportExportRoute = AuthHomeReportExportRouteImport.update({
  id: '/export',
  path: '/export',
  getParentRoute: () => AuthHomeReportRoute,
} as any)
const AuthHomeReportReqIdRoute = AuthHomeReportReqIdRouteImport.update({
  id: '/$reqId',
  path: '/$reqId',
  getParentRoute: () => AuthHomeReportRoute,
} as any)
const AuthHomeRReceiptIdRoute = AuthHomeRReceiptIdRouteImport.update({
  id: '/r/$receiptId',
  path: '/r/$receiptId',
  getParentRoute: () => AuthHomeRoute,
} as any)
const AuthHomeTTripIdAddReceiptRoute =
  AuthHomeTTripIdAddReceiptRouteImport.update({
    id: '/add-receipt',
    path: '/add-receipt',
    getParentRoute: () => AuthHomeTTripIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthHomeIndexRoute
  '/consent': typeof ConsentRoute
  '/login': typeof LoginRoute
  '/maintenance': typeof MaintenanceRoute
  '/jobs': typeof AuthJobsRoute
  '/profile': typeof AuthProfileRoute
  '/settings': typeof AuthSettingsRoute
  '/report': typeof AuthHomeReportRouteWithChildren
  '/r/$receiptId': typeof AuthHomeRReceiptIdRoute
  '/report/$reqId': typeof AuthHomeReportReqIdRoute
  '/report/export': typeof AuthHomeReportExportRoute
  '/t/$tripId': typeof AuthHomeTTripIdRouteWithChildren
  '/t/': typeof AuthHomeTIndexRoute
  '/t/$tripId/add-receipt': typeof AuthHomeTTripIdAddReceiptRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthHomeIndexRoute
  '/consent': typeof ConsentRoute
  '/login': typeof LoginRoute
  '/maintenance': typeof MaintenanceRoute
  '/jobs': typeof AuthJobsRoute
  '/profile': typeof AuthProfileRoute
  '/settings': typeof AuthSettingsRoute
  '/report': typeof AuthHomeReportRouteWithChildren
  '/r/$receiptId': typeof AuthHomeRReceiptIdRoute
  '/report/$reqId': typeof AuthHomeReportReqIdRoute
  '/report/export': typeof AuthHomeReportExportRoute
  '/t/$tripId': typeof AuthHomeTTripIdRouteWithChildren
  '/t': typeof AuthHomeTIndexRoute
  '/t/$tripId/add-receipt': typeof AuthHomeTTripIdAddReceiptRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/consent': typeof ConsentRoute
  '/login': typeof LoginRoute
  '/maintenance': typeof MaintenanceRoute
  '/_auth/_home': typeof AuthHomeRouteWithChildren
  '/_auth/jobs': typeof AuthJobsRoute
  '/_auth/profile': typeof AuthProfileRoute
  '/_auth/settings': typeof AuthSettingsRoute
  '/_auth/_home/report': typeof AuthHomeReportRouteWithChildren
  '/_auth/_home/': typeof AuthHomeIndexRoute
  '/_auth/_home/r/$receiptId': typeof AuthHomeRReceiptIdRoute
  '/_auth/_home/report/$reqId': typeof AuthHomeReportReqIdRoute
  '/_auth/_home/report/export': typeof AuthHomeReportExportRoute
  '/_auth/_home/t/$tripId': typeof AuthHomeTTripIdRouteWithChildren
  '/_auth/_home/t/': typeof AuthHomeTIndexRoute
  '/_auth/_home/t/$tripId/add-receipt': typeof AuthHomeTTripIdAddReceiptRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/consent'
    | '/login'
    | '/maintenance'
    | '/jobs'
    | '/profile'
    | '/settings'
    | '/report'
    | '/r/$receiptId'
    | '/report/$reqId'
    | '/report/export'
    | '/t/$tripId'
    | '/t/'
    | '/t/$tripId/add-receipt'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/consent'
    | '/login'
    | '/maintenance'
    | '/jobs'
    | '/profile'
    | '/settings'
    | '/report'
    | '/r/$receiptId'
    | '/report/$reqId'
    | '/report/export'
    | '/t/$tripId'
    | '/t'
    | '/t/$tripId/add-receipt'
  id:
    | '__root__'
    | '/_auth'
    | '/consent'
    | '/login'
    | '/maintenance'
    | '/_auth/_home'
    | '/_auth/jobs'
    | '/_auth/profile'
    | '/_auth/settings'
    | '/_auth/_home/report'
    | '/_auth/_home/'
    | '/_auth/_home/r/$receiptId'
    | '/_auth/_home/report/$reqId'
    | '/_auth/_home/report/export'
    | '/_auth/_home/t/$tripId'
    | '/_auth/_home/t/'
    | '/_auth/_home/t/$tripId/add-receipt'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  ConsentRoute: typeof ConsentRoute
  LoginRoute: typeof LoginRoute
  MaintenanceRoute: typeof MaintenanceRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/maintenance': {
      id: '/maintenance'
      path: '/maintenance'
      fullPath: '/maintenance'
      preLoaderRoute: typeof MaintenanceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/consent': {
      id: '/consent'
      path: '/consent'
      fullPath: '/consent'
      preLoaderRoute: typeof ConsentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/settings': {
      id: '/_auth/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthSettingsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/profile': {
      id: '/_auth/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthProfileRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/jobs': {
      id: '/_auth/jobs'
      path: '/jobs'
      fullPath: '/jobs'
      preLoaderRoute: typeof AuthJobsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/_home': {
      id: '/_auth/_home'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthHomeRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/_home/': {
      id: '/_auth/_home/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthHomeIndexRouteImport
      parentRoute: typeof AuthHomeRoute
    }
    '/_auth/_home/report': {
      id: '/_auth/_home/report'
      path: '/report'
      fullPath: '/report'
      preLoaderRoute: typeof AuthHomeReportRouteImport
      parentRoute: typeof AuthHomeRoute
    }
    '/_auth/_home/t/': {
      id: '/_auth/_home/t/'
      path: '/t'
      fullPath: '/t/'
      preLoaderRoute: typeof AuthHomeTIndexRouteImport
      parentRoute: typeof AuthHomeRoute
    }
    '/_auth/_home/t/$tripId': {
      id: '/_auth/_home/t/$tripId'
      path: '/t/$tripId'
      fullPath: '/t/$tripId'
      preLoaderRoute: typeof AuthHomeTTripIdRouteImport
      parentRoute: typeof AuthHomeRoute
    }
    '/_auth/_home/report/export': {
      id: '/_auth/_home/report/export'
      path: '/export'
      fullPath: '/report/export'
      preLoaderRoute: typeof AuthHomeReportExportRouteImport
      parentRoute: typeof AuthHomeReportRoute
    }
    '/_auth/_home/report/$reqId': {
      id: '/_auth/_home/report/$reqId'
      path: '/$reqId'
      fullPath: '/report/$reqId'
      preLoaderRoute: typeof AuthHomeReportReqIdRouteImport
      parentRoute: typeof AuthHomeReportRoute
    }
    '/_auth/_home/r/$receiptId': {
      id: '/_auth/_home/r/$receiptId'
      path: '/r/$receiptId'
      fullPath: '/r/$receiptId'
      preLoaderRoute: typeof AuthHomeRReceiptIdRouteImport
      parentRoute: typeof AuthHomeRoute
    }
    '/_auth/_home/t/$tripId/add-receipt': {
      id: '/_auth/_home/t/$tripId/add-receipt'
      path: '/add-receipt'
      fullPath: '/t/$tripId/add-receipt'
      preLoaderRoute: typeof AuthHomeTTripIdAddReceiptRouteImport
      parentRoute: typeof AuthHomeTTripIdRoute
    }
  }
}

interface AuthHomeReportRouteChildren {
  AuthHomeReportReqIdRoute: typeof AuthHomeReportReqIdRoute
  AuthHomeReportExportRoute: typeof AuthHomeReportExportRoute
}

const AuthHomeReportRouteChildren: AuthHomeReportRouteChildren = {
  AuthHomeReportReqIdRoute: AuthHomeReportReqIdRoute,
  AuthHomeReportExportRoute: AuthHomeReportExportRoute,
}

const AuthHomeReportRouteWithChildren = AuthHomeReportRoute._addFileChildren(
  AuthHomeReportRouteChildren,
)

interface AuthHomeTTripIdRouteChildren {
  AuthHomeTTripIdAddReceiptRoute: typeof AuthHomeTTripIdAddReceiptRoute
}

const AuthHomeTTripIdRouteChildren: AuthHomeTTripIdRouteChildren = {
  AuthHomeTTripIdAddReceiptRoute: AuthHomeTTripIdAddReceiptRoute,
}

const AuthHomeTTripIdRouteWithChildren = AuthHomeTTripIdRoute._addFileChildren(
  AuthHomeTTripIdRouteChildren,
)

interface AuthHomeRouteChildren {
  AuthHomeReportRoute: typeof AuthHomeReportRouteWithChildren
  AuthHomeIndexRoute: typeof AuthHomeIndexRoute
  AuthHomeRReceiptIdRoute: typeof AuthHomeRReceiptIdRoute
  AuthHomeTTripIdRoute: typeof AuthHomeTTripIdRouteWithChildren
  AuthHomeTIndexRoute: typeof AuthHomeTIndexRoute
}

const AuthHomeRouteChildren: AuthHomeRouteChildren = {
  AuthHomeReportRoute: AuthHomeReportRouteWithChildren,
  AuthHomeIndexRoute: AuthHomeIndexRoute,
  AuthHomeRReceiptIdRoute: AuthHomeRReceiptIdRoute,
  AuthHomeTTripIdRoute: AuthHomeTTripIdRouteWithChildren,
  AuthHomeTIndexRoute: AuthHomeTIndexRoute,
}

const AuthHomeRouteWithChildren = AuthHomeRoute._addFileChildren(
  AuthHomeRouteChildren,
)

interface AuthRouteChildren {
  AuthHomeRoute: typeof AuthHomeRouteWithChildren
  AuthJobsRoute: typeof AuthJobsRoute
  AuthProfileRoute: typeof AuthProfileRoute
  AuthSettingsRoute: typeof AuthSettingsRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthHomeRoute: AuthHomeRouteWithChildren,
  AuthJobsRoute: AuthJobsRoute,
  AuthProfileRoute: AuthProfileRoute,
  AuthSettingsRoute: AuthSettingsRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  ConsentRoute: ConsentRoute,
  LoginRoute: LoginRoute,
  MaintenanceRoute: MaintenanceRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
